import { render, staticRenderFns } from "./StudioVideo.vue?vue&type=template&id=aa6b2912&"
import script from "./StudioVideo.vue?vue&type=script&lang=js&"
export * from "./StudioVideo.vue?vue&type=script&lang=js&"
import style0 from "./StudioVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports